// Cruiser-focused motorcycle imagery + Egypt / GCC environments (Unsplash).
const U = (id, w = 1200, q = 80) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=${q}`;

export const BIKES = {
  // Rider on a cruiser at sunset, motion-blurred open road — hero
  heroRider: U("1558981806-ec527fa84c39", 1500, 82),
  // Classic Royal Enfield cruiser, dramatic sky
  classicCruiser: U("1622185135505-2d795003994a", 1000),
  // Orange muscle cruiser cornering in motion
  orangeCruiser: U("1558980664-10e7170b5df9", 1400, 80),
};

// Egypt & GCC environments
export const PLACES = {
  // Wadi desert rock formations (desert-run terrain)
  desertWadi: U("1547235001-d703406d3f17", 1600, 80),
  // Warm desert dunes at golden hour
  desertDunes: U("1682687220198-88e9bdea9931", 1400, 80),
  // Giza pyramids at golden hour (Egypt)
  egyptPyramids: U("1539768942893-daf53e448371", 1000),
  // Dubai skyline at sunset (Burj Khalifa)
  dubaiSkyline: U("1512453979798-5ea266f8880c", 1000),
  // Burj Al Arab, Gulf coastal
  gulfCoast: U("1518684079-3c830dcef090", 1000),
};
